<div class="d-flex">
	<div class="display-6 ms-1 mt-2 mb-1 d-flex">
		FocusPay Batches
		<div class="ms-4 my-auto">
			<p-dropdown
				#merchantIdSelectList
				[options]="merchantIdList"
				optionLabel="label"
				optionValue="value"
				name="merchantIdSelectList"
				[(ngModel)]="merchantIdSelected"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				itemSize="30"
				filter="true"
				styleClass="my-auto"
				(filterBy)="app.keys(merchantIdList)"
				(onChange)="changeMerchantId($event)"
			></p-dropdown>
		</div>
	</div>

	<div class="ms-auto">
		<p-button *ngIf="displayDashboard" pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="displayDashboard = !displayDashboard">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'gauge-max']" size="lg" class="ms-1 me-2"></fa-icon>
					Hide Dashboard
				</div>
			</ng-template>
		</p-button>
		<p-button *ngIf="!displayDashboard" pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="displayDashboard = !displayDashboard">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['fas', 'gauge-max']" size="lg" class="ms-1 me-2"></fa-icon>
					View Dashboard
				</div>
			</ng-template>
		</p-button>
	</div>
</div>
<p-divider></p-divider>

<ng-container *ngIf="venueService.subscriptionVenue.value.ccProcessor === 5">
	<div class="mb-3" *ngIf="displayDashboard">
		<app-credit-dashboard-header #creditDashboardHeader></app-credit-dashboard-header>
		<app-credit-dashboard-chart></app-credit-dashboard-chart>
	</div>

	<app-batch-list #batchListComponent [merchantId]="merchantIdSelected"></app-batch-list>
</ng-container>

<ng-container *ngIf="venueService.subscriptionVenue.value.ccProcessor !== 5">
	<app-credit-not-focuspay></app-credit-not-focuspay>
</ng-container>
